import React, { Component } from "react";
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";

import { Alert, Card, CardBody, Col, Container, Row, Label } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

// actions
import { apiError } from "../../store/actions";
import { loginRequest } from "../../store/actions";

import Logo from "../../assets/images/Logo.png";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    this.props.apiError("");
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="account-pages min-vh-100 d-flex align-items-center"
          style={{ background: "#2A3042" }}
        >
          <MetaTags>
            <title>DigiLab Login</title>
          </MetaTags>
          <Container className=" my-auto">
            <Row className="justify-content-center">
              <Col md={12} lg={12} xl={12} className="">
                <Card
                  className="overflow-hidden"
                  style={{ backgroundColor: "#2A3042" }}
                >
                  <CardBody className="pt-0 ">
                    <div className="mb-4  d-flex justify-content-center">
                      <img src={Logo} alt="Logo For Image" className="mw-100" />
                    </div>

                    {/* For Form */}
                    <div className="mx-auto pt-4 " style={{ width: "45%" }}>
                      {/* Add Welcome Back Heading */}
                      <h3
                        className="mb-4"
                        style={{
                          fontSize: 32,
                          color: "white",
                          fontWeight: "lighter",
                        }}
                      >
                        Welcome Back!
                      </h3>
                      {this.props.error && (
                        <Alert color="danger" className="text-center">
                          {this.props.error.response.data.detail}
                        </Alert>
                      )}
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          email: (this.state && this.state.email) || "",
                          password: (this.state && this.state.password) || "",
                        }}
                        validationSchema={Yup.object().shape({
                          email: Yup.string()
                            .required("Please Enter Your Email")
                            .email("Please Enter Valid Email"),
                          password: Yup.string()
                            .required("Please Enter Valid Password")
                            .test(
                              "password",
                              "Password must contain at least one number and one letter",
                              function (value) {
                                return /^[a-zA-Z0-9]+$/.test(value);
                              }
                            ),
                        })}
                        onSubmit={values => {
                          // Call Function ( action ) to log in and change the states
                          this.props.loginRequest(values, this.props.history);
                        }}
                      >
                        {({ errors, status, touched }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label
                                for="email"
                                style={{
                                  fontWeight: "lighter",
                                }}
                                className="form-label"
                              >
                                Username
                              </Label>
                              <Field
                                name="email"
                                type="text"
                                placeholder="Enter Your Email"
                                style={{
                                  backgroundColor: "rgba(0,0,0,0)",
                                  color: "white",
                                }}
                                className={
                                  "form-control" +
                                  (errors.email && touched.email
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                            <div className="mb-3">
                              <Label
                                for="password"
                                className="form-label"
                                placeholder="Enter Your Password"
                                style={{
                                  fontWeight: "lighter",
                                }}
                              >
                                Password
                              </Label>
                              <div className="input-group auth-pass-inputgroup">
                                <Field
                                  name="password"
                                  placeholder="Enter Password"
                                  type={
                                    this.state.visible ? "text" : "password"
                                  }
                                  style={{
                                    backgroundColor: "rgba(0,0,0,0)",
                                    color: "white",
                                    borderWidth: 1,
                                    borderColor: "white",
                                    borderRight: 0,
                                  }}
                                  autoComplete="true"
                                  className={
                                    "form-control" +
                                    (errors.password && touched.password
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <button
                                  className="btn"
                                  type="button"
                                  style={{
                                    borderWidth: 1,
                                    borderColor: "white",
                                    borderLeft: 0,
                                  }}
                                  id="password-addon"
                                  onClick={() => {
                                    this.setState({
                                      visible: !this.state.visible,
                                    });
                                  }}
                                >
                                  {this.state.visible ? (
                                    <i className="mdi mdi-eye-off"></i>
                                  ) : (
                                    <i className="mdi mdi-eye"></i>
                                  )}
                                </button>
                                <ErrorMessage
                                  name="password"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mt-3 d-grid">
                              <button
                                className="btn btn-primary btn-block"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>

                            <div className="mt-4 text-center">
                              {/* <Link
                                // to="/forgot-password"
                                to="/pages-coming"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock me-1" /> Forgot your
                                password?
                              </Link> */}
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginRequest: PropTypes.func,
};

const mapStateToProps = state => {
  const { error } = state.ProfilingReducer;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginRequest, apiError })(Login)
);
